<template>
  <div>

    <div class="register-products-nav container-fluid">
      <div class="row">
        <div class="offset-1 col-10  offset-xl-1 col-xl-10">
          <div class="row">
            <div class="tab-cnt col-lg-4 d-none d-lg-block" style="padding-left: 0px;">
              <div style="cursor:pointer;" class="nav-inner" v-html="$t('common.nav_step1')" @click="goToStep1()"></div>
            </div>
            <div class="tab-cnt col-lg-4">
              <div class="nav-inner active" v-html="$t('common.nav_step2')"></div>
            </div>
            <div class="tab-cnt col-lg-4 d-none d-lg-block" style="padding-right: 0px;">
              <div class="nav-inner" v-html="$t('common.nav_step3')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="offset-1 col-10 register-products">
          
          <div class="row justify-content-center">
            <div class="col-10">
              <h2 class="register-products__heading">{{ $t('step2.heading') }}</h2>

              <div class="row">
                <categoryBox v-if="isLoaded" v-for="category in categories" v-bind:key="category.id" v-bind:category="category"></categoryBox>
              </div>

            </div>
          </div>

          <div v-if="readyToRegister" class="row">
            <div class="col-12 mt-4 text-center">
              <button @click.prevent="finishRegister()" class="amica-btn amica-btn-red btn-next-step">{{ $t('step2.btn_register') }}</button>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import CategoryBox from '@/components/categoryBox';

  export default {
    name: "RegisterStep2",
    data () {
      return {
        isLoaded: false,
        categories: [
          {
            id: 1,
            name: 'oven'
          },
          {
            id: 2,
            name: 'cooker'
          },
          {
            id: 3,
            name: 'hob'
          }
        ]
      }
    },
    computed: {
      readyToRegister () {
        let categoriesCount = this.$store.getters.getRegisteredCategoriesIds.length
        return categoriesCount > 0 ? true : false
      }
    },
    methods: {
      fetchProducts () {
        let cmp = this
        cmp.$store.dispatch('fetchProductsAndSplitIntoCategories').then(() => {
          cmp.isLoaded = true
        }).catch(function (e) {
          console.log('Nie udało się pobrać produktów promocyjnych')
        })
      },
      finishRegister () {
        this.$store.dispatch('finalizeRegistration').then((res) => {
          if (res.data.code === 200) {
            this.$router.push('/product-registration/step-3')
          } else {
            alert('Nie udało się zarejestrować produktów')
          }
        })
      },
      goToStep1 () {
        this.$router.push('/product-registration/step-1');
      }
    },
    mounted () {
      this.fetchProducts()
    },
    components: {
      CategoryBox
    }
  }
</script>

<style lang="scss" scoped>

  .form-group label {
    font-size: 14px;
  }

  .register-products-nav {
    margin-top: 60px;

    .nav-inner {
      width: 100%;
      padding: 20px 0;
      font-size: 16px;
      text-align: center;
      text-transform: uppercase;
      background: #ececec;
      opacity: 0.6;

      position: relative;
      z-index: 1;
      margin-bottom: -1px;

      border: 1px #dedede solid;
      border-radius: 10px 10px 0px 0px;
      -moz-border-radius: 10px 10px 0px 0px;
      -webkit-border-radius: 10px 10px 0px 0px;

      @media only screen and (max-width : 1199px) {
        font-size: 13px;
      }

      @media only screen and (max-width : 991px) {
        font-size: 16px;
      }

      &.active {
        border-bottom: 1px #fff solid;
        background: #fff;
        opacity: 1;
      }

      & /deep/ span {
        color: #e41429;
        font-weight: 900;
      }
    }

    .tab-cnt {
      @media only screen and (max-width : 991px) {
        padding-right: 0px;
        padding-left: 0px;
      }
    }
  }

  .register-products {
    border: 1px #dedede solid;
    padding-top: 50px;
    padding-bottom: 20px;

    .register-products__heading {
      color: #000;
      font-size: 38px;
      font-weight: 300;
      margin-bottom: 50px;
    }
  }

  .current-prize-info {
    font-size: 18px;

    span {
      font-size: 12px;
    }

    strong {
      color: #e41429;
    }

    & + button {
      padding-left: 40px;
      padding-right: 40px;
    }
  }

</style>
